import React from 'react';
import { connect } from 'react-redux';

import RufsError from '../../errors/rufsError.jsx';
import partnerPropTypes from '../../partnerPropTypes';

const DelayPaymentError = ({ partner }) => (
    <RufsError>
        Vi kan ikke utsette betalingen til {partner.name} akkurat nå. Prøv igjen
        om litt.
    </RufsError>
);

function mapStateToProps(state) {
    return {
        partner: state.partner,
    };
}

DelayPaymentError.propTypes = {
    partner: partnerPropTypes.isRequired,
};

export default connect(mapStateToProps)(DelayPaymentError);



// WEBPACK FOOTER //
// ./safeTrade/buyer/resolution/delayPaymentError.jsx